import { render, staticRenderFns } from "./AyunAssetBased.vue?vue&type=template&id=2366ea12&scoped=true&"
import script from "./AyunAssetBased.vue?vue&type=script&lang=js&"
export * from "./AyunAssetBased.vue?vue&type=script&lang=js&"
import style0 from "./AyunAssetBased.vue?vue&type=style&index=0&id=2366ea12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2366ea12",
  null
  
)

export default component.exports